import { Modal, Text } from '@simplywallst/ui-core';

import { useCompany } from '@/hooks/useCompany';
import type { Holding } from '@/hooks/portfolio/usePortfolio';
import { formatterCurrency } from '@/utilities/format';

import { useRematchHoldingMutation } from '../../hooks/useRematchHoldingMutation';

import { TextWrapper } from './styled';

interface Props {
  holding: Holding;
  companyUniqueSymbol: string;
  onClose: () => void;
  onSuccess: () => void;
  onError: () => void;
}

export const RematchConfirmationModal = ({
  holding,
  companyUniqueSymbol,
  onClose,
  onSuccess,
  onError,
}: Props) => {
  const { data, status: companyStatus } = useCompany(companyUniqueSymbol);
  const { mutate, status: mutationStatus } = useRematchHoldingMutation({
    onSuccess,
    onError,
  });

  const company = data?.data;

  if (companyStatus === 'error') {
    return null;
  }

  const handleClick = () => {
    mutate({
      id: holding.id,
      uniqueSymbol: companyUniqueSymbol,
    });
  };

  return (
    <Modal
      isLoading={companyStatus === 'pending'}
      data-cy-id="rematch-confirmation-modal"
      title={`Matching ${holding.symbol} with ${company?.unique_symbol ?? ''}`}
      onSecondaryClick={onClose}
      secondaryLabel="Cancel"
      primaryLabel="Match ticker"
      onPrimaryClick={handleClick}
      primaryLoading={mutationStatus === 'pending'}
    >
      {typeof company === 'undefined' ? null : (
        <>
          <Text typography="large" color="spaceGray">
            You're about to match ticker {holding.symbol} with
          </Text>
          <TextWrapper>
            <Text typography="megaStrong" color="spaceGray">
              {company.unique_symbol}
            </Text>
            <Text typography="megaStrong" color="spaceGray">
              {company.name}
            </Text>
          </TextWrapper>
          <Text typography="large" color="spaceGray">
            Last price:{' '}
            {formatterCurrency(
              company.analysis?.data.share_price,
              company.info.data.currency
            )}
          </Text>
        </>
      )}
    </Modal>
  );
};
